import { createNotivue } from 'notivue'

import 'notivue/notifications.css'

import 'notivue/animations.css'

export const notivue = createNotivue()
